import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Mainnet-Beta", -1)
const _hoisted_3 = { class: "text-gray-500 text-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "GenesysGo Mainnet", -1)
const _hoisted_5 = { class: "text-gray-500 text-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Testnet", -1)
const _hoisted_7 = { class: "text-gray-500 text-sm" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Devnet", -1)
const _hoisted_9 = { class: "text-gray-500 text-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "GenesysGo Devnet", -1)
const _hoisted_11 = { class: "text-gray-500 text-sm" }

import { toRefs } from 'vue';
import { Cluster, clusterApiUrl } from '@solana/web3.js';
import { GENESYSGO_DEVNET, GENESYSGO_MAINNET, useWorkspace } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  props: {
    close: null
  },
  setup(__props: any) {

const props = __props as {
  close:() => void,
}



const { cluster } = useWorkspace();
const { close } = toRefs(props);

const updateClusterUrl = (rpc: string) => {
  cluster.value = rpc;
  close.value();
};

const updateCluster = (rpc: Cluster) => updateClusterUrl(clusterApiUrl(rpc));

return (_ctx: any,_cache: any) => {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, { close: _unref(close) }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "block w-full bg-gradient-to-br from-gray-50/50 to-blue-50/50 rounded-lg px-4 py-2 text-left border hover:border-indigo-500 hover:shadow-xl hover:shadow-purple-500/10 hover:bg-gradient-to-br hover:from-white/50 hover:to-blue-200/50 transition",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateCluster('mainnet-beta')))
        }, [
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(clusterApiUrl)('mainnet-beta')), 1)
        ]),
        _createElementVNode("button", {
          class: "block w-full bg-gradient-to-br from-gray-50/50 to-blue-50/50 rounded-lg px-4 py-2 text-left border hover:border-indigo-500 hover:shadow-xl hover:shadow-purple-500/10 hover:bg-gradient-to-br hover:from-white/50 hover:to-blue-200/50 transition",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateClusterUrl(_unref(GENESYSGO_MAINNET))))
        }, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(GENESYSGO_MAINNET)), 1)
        ]),
        _createElementVNode("button", {
          class: "block w-full bg-gradient-to-br from-gray-50/50 to-blue-50/50 rounded-lg px-4 py-2 text-left border hover:border-indigo-500 hover:shadow-xl hover:shadow-purple-500/10 hover:bg-gradient-to-br hover:from-white/50 hover:to-blue-200/50 transition",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (updateCluster('testnet')))
        }, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(clusterApiUrl)('testnet')), 1)
        ]),
        _createElementVNode("button", {
          class: "block w-full bg-gradient-to-br from-gray-50/50 to-blue-50/50 rounded-lg px-4 py-2 text-left border hover:border-indigo-500 hover:shadow-xl hover:shadow-purple-500/10 hover:bg-gradient-to-br hover:from-white/50 hover:to-blue-200/50 transition",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (updateCluster('devnet')))
        }, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(clusterApiUrl)('devnet')), 1)
        ]),
        _createElementVNode("button", {
          class: "block w-full bg-gradient-to-br from-gray-50/50 to-blue-50/50 rounded-lg px-4 py-2 text-left border hover:border-indigo-500 hover:shadow-xl hover:shadow-purple-500/10 hover:bg-gradient-to-br hover:from-white/50 hover:to-blue-200/50 transition",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (updateClusterUrl(_unref(GENESYSGO_DEVNET))))
        }, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(GENESYSGO_DEVNET)), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["close"]))
}
}

})